exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".graphMarketPerformance {\n  width: 700px;\n  height: 400px; }\n\n.configGraphMarketPerformance {\n  width: 100%;\n  height: 400px;\n  background-color: #FFFFFF; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/historical-indices/historical-indices.component.scss
// module id = ../../../../../src/app/market-level/historical-indices/historical-indices.component.scss
// module chunks = main